import React from 'react';
import classnames from 'classnames';
import { Typography, TypographyProps } from '@material-ui/core';

export function UnderlinedText({ className, ...props }: TypographyProps) {
  const c = classnames('underline', className);
  return (<Typography className={c} {...props} />);
}
